// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"808":"f4037f9c","856":"d6769a0a","952":"7a41ee71"}[chunkId] + ".chunk.js";
};